import { render, staticRenderFns } from "./locationUpdate.vue?vue&type=template&id=2fb2d764&scoped=true&"
import script from "./locationUpdate.vue?vue&type=script&lang=js&"
export * from "./locationUpdate.vue?vue&type=script&lang=js&"
import style0 from "./locationUpdate.vue?vue&type=style&index=0&id=2fb2d764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2d764",
  null
  
)

component.options.__file = "locationUpdate.vue"
export default component.exports